/* eslint-disable react/button-has-type */
import React from 'react';
import jwtDecode from 'jwt-decode';
import { getStorage } from '../utils/functions/localstorage';
import Avatar from '@mui/material/Avatar';
import Divider from '@mui/material/Divider';
import Button from '@mui/material/Button';

function SettingUser() {
  const tokened = getStorage('token');
  const decode = jwtDecode(tokened);
  const nameCustomer = decode.NAME;
  const taxIdCustomer = decode.TAX_ID;
  const eMailCustomer = decode.EMAIL;

  const register = async () => {
    try {
      const path = `${process.env.REACT_APP_API_URL}/notify/line/register?token=${tokened}`;
      window.location.replace(path);
    } catch (error) {
      console.log(error);
    }
  };
  return (
    <div>
      <div className="my-2 ml-2">
        <div className="text-lg font-light mt-5 selection:flex items-center justify-between">
          <div>บัญชีผู้ใช้</div>
          <div />
        </div>
      </div>
      <div className="flex justify-center md:justify-start">
        <div className="md:w-[450px]  px-2 py-4">
          <div className="px-10 py-6 bg-white rounded-lg border border-gray-200 shadow-md ">
            <div className="flex justify-center pb-4">
              <Avatar sx={{ width: 100, height: 100 }}>P</Avatar>
            </div>
            <div className="flex justify-center pb-4">{nameCustomer} </div>
            <div className="flex justify-center pb-4">
              <Button
                variant="outlined"
                onClick={register}
                sx={{ borderRadius: 10, width: '180px' }}
              >
                ลงทะเบียน
              </Button>
            </div>
            <Divider />
            <div className="md:ml-10 ml-2 pt-4 pb-2  text-xs md:text-base">
              เลขที่ผู้เสียภาษี : {taxIdCustomer}
            </div>
            <div className=" md:ml-10 ml-2 pb-4  text-xs md:text-base">E-mail : {eMailCustomer}</div>
            <br />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SettingUser;
